export enum NewsTabCategory {
    'Primary' = 'Primary',
    'Secondary' = 'Secondary',
    'Research' = 'Research',
    'CleansingNotice' = "CleansingNotice",
    'RatingAction' = "RatingAction",
    'PeopleAndFunds' = "PeopleAndFunds",
    'All' = 'All',
}
